/* PRODUCTS */
const actionTypes = Object.freeze({
    CLEAR_STATE: 'PRODUCTS/CLEAR_STATE',

    GET_PRODUCTS: 'PRODUCTS/GET_PRODUCTS',
    GET_PRODUCTS_SUCCESS: 'PRODUCTS/GET_PRODUCTS_SUCCESS',
    GET_PRODUCTS_FAILED: 'PRODUCTS/GET_PRODUCTS_FAILED',

    // Optimistic per-row flag patch (status switch on the list / header).
    PATCH_PRODUCT_ROW: 'PRODUCTS/PATCH_PRODUCT_ROW',
    PATCH_PRODUCT_ROW_SUCCESS: 'PRODUCTS/PATCH_PRODUCT_ROW_SUCCESS',
    PATCH_PRODUCT_ROW_FAILED: 'PRODUCTS/PATCH_PRODUCT_ROW_FAILED',

    GET_PRODUCT: 'PRODUCTS/GET_PRODUCT',
    GET_PRODUCT_SUCCESS: 'PRODUCTS/GET_PRODUCT_SUCCESS',
    GET_PRODUCT_FAILED: 'PRODUCTS/GET_PRODUCT_FAILED',

    PATCH_PRODUCT: 'PRODUCTS/PATCH_PRODUCT',
    PATCH_PRODUCT_SUCCESS: 'PRODUCTS/PATCH_PRODUCT_SUCCESS',
    PATCH_PRODUCT_FAILED: 'PRODUCTS/PATCH_PRODUCT_FAILED',

    POST_PRODUCT: 'PRODUCTS/POST_PRODUCT',
    POST_PRODUCT_SUCCESS: 'PRODUCTS/POST_PRODUCT_SUCCESS',
    POST_PRODUCT_FAILED: 'PRODUCTS/POST_PRODUCT_FAILED',

    POST_PRODUCT_CLONE: 'PRODUCTS/POST_PRODUCT_CLONE',
    POST_PRODUCT_CLONE_SUCCESS: 'PRODUCTS/POST_PRODUCT_CLONE_SUCCESS',
    POST_PRODUCT_CLONE_FAILED: 'PRODUCTS/POST_PRODUCT_CLONE_FAILED',

    POST_PRODUCT_IMAGE_SUCCESS: 'PRODUCTS/POST_PRODUCT_IMAGE_SUCCESS',
    POST_PRODUCT_IMAGE_FAILED: 'PRODUCTS/POST_PRODUCT_IMAGE_FAILED',

    GET_PRODUCT_IMAGES: 'PRODUCTS/GET_PRODUCT_IMAGES',
    GET_PRODUCT_IMAGES_SUCCESS: 'PRODUCTS/GET_PRODUCT_IMAGES_SUCCESS',
    GET_PRODUCT_IMAGES_FAILED: 'PRODUCTS/GET_PRODUCT_IMAGES_FAILED',

    DELETE_PRODUCT_IMAGE: 'PRODUCTS/DELETE_PRODUCT_IMAGE',
    DELETE_PRODUCT_IMAGE_SUCCESS: 'PRODUCTS/DELETE_PRODUCT_IMAGE_SUCCESS',
    DELETE_PRODUCT_IMAGE_FAILED: 'PRODUCTS/DELETE_PRODUCT_IMAGE_FAILED',

    PATCH_PRODUCT_IMAGES: 'PRODUCTS/PATCH_PRODUCT_IMAGES',
    PATCH_PRODUCT_IMAGES_DONE: 'PRODUCTS/PATCH_PRODUCT_IMAGES_DONE',

    GET_VARIANTS: 'PRODUCTS/GET_VARIANTS',
    GET_VARIANTS_SUCCESS: 'PRODUCTS/GET_VARIANTS_SUCCESS',
    GET_VARIANTS_FAILED: 'PRODUCTS/GET_VARIANTS_FAILED',

    POST_VARIANT: 'PRODUCTS/POST_VARIANT',
    POST_VARIANT_SUCCESS: 'PRODUCTS/POST_VARIANT_SUCCESS',
    POST_VARIANT_FAILED: 'PRODUCTS/POST_VARIANT_FAILED',

    PATCH_VARIANT: 'PRODUCTS/PATCH_VARIANT',
    PATCH_VARIANT_SUCCESS: 'PRODUCTS/PATCH_VARIANT_SUCCESS',
    PATCH_VARIANT_FAILED: 'PRODUCTS/PATCH_VARIANT_FAILED',

    // Optimistic per-row flag patch on a variant (status switch in the variants tab).
    PATCH_VARIANT_ROW: 'PRODUCTS/PATCH_VARIANT_ROW',
    PATCH_VARIANT_ROW_SUCCESS: 'PRODUCTS/PATCH_VARIANT_ROW_SUCCESS',
    PATCH_VARIANT_ROW_FAILED: 'PRODUCTS/PATCH_VARIANT_ROW_FAILED',

    GET_OPTION_VALUES: 'PRODUCTS/GET_OPTION_VALUES',
    GET_CATEGORIES: 'PRODUCTS/GET_CATEGORIES',
    GET_SUPPLIERS: 'PRODUCTS/GET_SUPPLIERS',
    GET_LOOKUP_VALUES: 'PRODUCTS/GET_LOOKUP_VALUES'
});

export default actionTypes;
